export const getImageData = (
  data,
  returnType,
  plpPage = true,
  defaultImage = "IMGITEMISO"
) => {
  const sku = data["sku_s"]
    ? data["sku_s"]
    : data["preferenceSku_s"] || data["masterSKU_s"]
  let imagestmp = []
  let setImagesData = []
  let setImgUrlData = ""
  const setImages = d => (setImagesData = d)
  const setImgUrl = d => (setImgUrlData = d)

  const productVariantImages = data["productImages.labelWithUrl_s"]
    ? [data["productImages.labelWithUrl_s"]]
    : data["productImages.labelWithUrl_ss"]
  let setDefaultProductImage = ""
  let setHoverProductImage = ""
  let isHover = true
  if (productVariantImages?.length > 0) {
    const variantImages = productVariantImages.filter(
      img => sku === img.split("|")[0]
    )
    if (plpPage) {
      variantImages.find(img => {
        const imgDetails = img.split("|")

        if (imgDetails[2] === defaultImage) {
          setImgUrl(imgDetails[5])
          return (setDefaultProductImage = imgDetails[1])
        } else {
          setDefaultProductImage = variantImages[0].split("|")[1]
          setImgUrl(variantImages[0].split("|")[5])
        }
      })
    } else {
      productVariantImages.find(img => {
        const imgDetails = img.split("|")
        if (sku === imgDetails[0]) {
          setImgUrl(imgDetails[5])
          return (setDefaultProductImage = imgDetails[1])
        }
      })
    }

    imagestmp.push(setDefaultProductImage)
    if (plpPage) {
      if (setHoverProductImage === "") {
        isHover = false
      }
      isHover === false
        ? imagestmp.push(setDefaultProductImage)
        : imagestmp.push(setHoverProductImage)
    }
  } else {
    imagestmp = ["MissingImage"]
  }

  setImages(imagestmp)
  if (returnType === "url") {
    return setImgUrlData
  } else {
    return setImagesData
  }
}

export const getColorData = (data, SWATCH_NA = "swatch_NA") => {
  let colorsTemp = []
  if (data["Color.SKU.Details_ss"]) {
    colorsTemp = data["Color.SKU.Details_ss"].map(color => {
      const d = color.split("|")
      return {
        name: d[0],
        swatch: d[1],
        sku: d[2],
        isStock: d[3],
        isDiscontinued: d[4],
        customerFacingSKU: d[5],
      }
    })
  } else if (data["Color.SKU.Details_s"]) {
    const d = data["Color.SKU.Details_s"].split("|")
    colorsTemp = [
      {
        name: d[0],
        swatch: d[1],
        sku: d[2],
        isStock: d[3],
        isDiscontinued: d[4],
        customerFacingSKU: d[5],
      },
    ]
  } else if (data["SKU.Details_ss"]) {
    colorsTemp = data["SKU.Details_ss"].map(color => {
      const d = color.split("|")
      return {
        name: "",
        swatch: SWATCH_NA,
        sku: d[0],
        isStock: d[1],
        isDiscontinued: d[2],
        customerFacingSKU: d[3],
      }
    })
  }

  const colorsTempVal = colorsTemp.filter(
    item =>
      item.swatch?.toLowerCase() !== SWATCH_NA.toLowerCase() &&
      (item.isDiscontinued === "false" ||
        Date.parse(item.isDiscontinued) > Date.now())
  )

  return colorsTempVal
}
